<template>
  <div class="slider-component" style="margin-top: 0!important;;">
    <div class="container">
      <img class="control" src="../../static/imgs/swiper_left.png" style="left: 30px;" alt="" @click="slidePrev">
      <div class="swiper-container swiper-no-swiping">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in platInfo" :key="index">
            <a :href="platInfo[index].platUrl" target="_blank" :class="{maintain:platInfo[index].maintain}">
              <img class="pad" src="../../static/imgs/plat.png" alt="">
              <img class="realImg" :src="item.imgUrl" alt="">
            </a>
          </div>
        </div>
        <!--        <div class="swiper-button-prev"></div>-->
        <!--        <div class="swiper-button-next"></div>-->
      </div>
      <img class="control" src="../../static/imgs/swiper_right.png" style="right: 30px;" alt="" @click="slideNext">

      <div class="plat_info">
        <div class="plat_name">
          <a class="plat_name" :class="{maintain:platInfo[realIndex].maintain}" :href="platInfo[realIndex].platUrl">{{platInfo[realIndex].platName}}</a>
        </div>
        <span class="plat_discrib" :class="{maintain:platInfo[realIndex].maintain}" >{{platInfo[realIndex].discrib}}</span>
        <!--            <a class="to_plat" :href="platInfo[realIndex].platUrl" target="_blank">进入平台</a>-->
      </div>
    </div>
  </div>


</template>

<script>
  //import Swiper from 'swiper';
  import Swiper from '../../node_modules/swiper/dist/js/swiper.min.js'

  export default {
    name: "slider",
    props: {
      platInfo: Array,
    },
    data() {
      return {
        swiper: null,
        realIndex: 0,
      }
    },
    methods: {
      slideNext(speed, runCallbacks) {
        this.swiper.slideNext()
      },
      slidePrev(speed, runCallbacks) {
        this.swiper.slidePrev()
      }
    },
    mounted() {
      let vthis = this;
      this.$nextTick(function () {
        this.swiper = new Swiper('.swiper-container', {
          loop: true,
          noSwipingClass: "stop",
          effect: 'coverflow',
          //grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          coverflowEffect: {
            rotate: 0,
            stretch: -135,
            depth: 400,
            modifier: 1,
            slideShadows: true,
          },
          on: {
            slideChangeTransitionEnd: function () {
              vthis.realIndex = this.realIndex;//切换结束时，告诉我现在是第几个slide
            },
          }
        })
      })
    },
    watch: {
      platInfo() {
        this.platInfo = platInfo;
      },
    }
  }
</script>

<style scoped>
  .maintain {
    pointer-events: none;
    color: #666 !important;
  }

  .slider-component {
    box-sizing: border-box;
    width: 100%;
    padding: 40px 0 90px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  .container {
    height: 100%;
    width: 90%;
    background-image: linear-gradient(to right, #343434,#C1C1C1, #CDCDCD,#CDCDCD,#C1C1C1,#343434);
    background-color: #fff;
    position: relative;
    overflow: auto;
  }

  .control {
    position: absolute;
    top: 50%;
    width: 70px;
    cursor: pointer;
    z-index: 10;
    transform: translateY(-50%);
  }


  .swiper-container {
    padding-top: 60px;
    /*width: 1320px;*/
    /*height: 420px;*/
    width: 1180px;
    height: 336px;
  }

  .swiper-slide {
    width: 435px;
    /*width: 497px;*/
    /*border-radius: 15px;*/
    overflow: hidden;
    background-color: transparent;
  }

  .swiper-slide .realImg {
    /*height: 260px;*/
    /*width: 460px;*/
    width: 402px;
    height: 224px;
    position: absolute;
    top: 20px;
    left: 16px;
  }

  .swiper-slide .pad {
    /*height: 420px;*/
    /*width: 497px;*/
    width: 435px;
    height: 336px;
  }

  .plat_info {
    width: 700px;
    margin: 0 auto;
    margin-top: 30px;
  }

  .plat_name {
    color: #000;;
    font-size: 27px;
    font-weight: bold;
    text-decoration: none;
    margin-bottom: 20px;
    text-decoration: underline;
    text-align: center;
  }

  .plat_discrib {
    line-height: 25px;
  }

  .to_plat {
    display: block;
    text-decoration: none;
    background: #297EBA;
    padding: 5px 10px;
    color: white;
    width: 80px;
    border-radius: 5px;
    margin: 0 auto;
    margin-top: 50px;
  }

  div::-webkit-scrollbar {
    width: 5px;
  }

  div::-webkit-scrollbar-track {
    background: #bfbfbf;
    border-radius:2px;
  }

  div::-webkit-scrollbar-thumb{
     background: #888;
     border-radius:2px;
  }
  div::-webkit-scrollbar-thumb:hover{
    background: #777;
  }
  div::-webkit-scrollbar-corner{
    background: #ddd;
  }

  div{
    /*三角箭头的颜色*/
    scrollbar-arrow-color: #ddd;
    /*滚动条滑块按钮的颜色*/
    scrollbar-face-color: #888;
    /*滚动条整体颜色*/
    scrollbar-highlight-color: #888;
    /*滚动条阴影*/
    scrollbar-shadow-color: #777;
    /*滚动条轨道颜色*/
    scrollbar-track-color: #bfbfbf;
    /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
    scrollbar-3dlight-color:#bfbfbf;
    /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
    scrollbar-darkshadow-color: #bfbfbf;
    /*滚动条基准颜色*/
    scrollbar-base-color: #bfbfbf;
  }

</style>



// WEBPACK FOOTER //
// src/components/slider.vue